import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function ChildAssets() {
  const [assets, setAssets] = useState([])
  const [children, setChildren] = useState([])
  const [selectedChild, setSelectedChild] = useState('')
  const [filter, setFilter] = useState('all')
  const [loading, setLoading] = useState(true)
  const [stats, setStats] = useState({})

  useEffect(() => {
    loadChildren()
    loadAssets()
  }, [])

  const loadChildren = () => {
    fetch(`${API}/children`)
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data) {
          setChildren(d.data)
          if (d.data.length > 0 && !selectedChild) {
            setSelectedChild(d.data[0].id)
          }
        }
      })
  }

  const loadAssets = () => {
    const url = selectedChild
      ? `${API}/child-assets/${selectedChild}${filter !== 'all' ? '?type=' + filter : ''}`
      : `${API}/child-assets${filter !== 'all' ? '?type=' + filter : ''}`
    
    fetch(url)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setAssets(d.data || [])
          setStats(d.stats || {})
        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (selectedChild || filter !== 'all') {
      loadAssets()
    }
  }, [selectedChild, filter])

  const getTypeIcon = (type) => {
    const icons = {
      'growth_video': '🎬',
      'painting_animation': '🎨',
      'ai_animation': '🤖',
      'photo': '📷'
    }
    return icons[type] || '📁'
  }

  const getTypeName = (type) => {
    const names = {
      'growth_video': '成长纪念视频',
      'painting_animation': '画作动画',
      'ai_animation': 'AI动画',
      'photo': '活动照片'
    }
    return names[type] || '其他'
  }

  const handleDelete = (id) => {
    if (!confirm('确定删除这个资产？')) return
    fetch(`${API}/child-assets/${id}`, { method: 'DELETE' })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          loadAssets()
          alert('删除成功')
        }
      })
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📦 孩子数字资产</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>查看和管理孩子的照片、视频、动画等数字资产</p>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: '成长纪念视频', value: stats.growth_videos || 0, icon: '🎬', color: '#1890ff' },
          { label: '画作动画', value: stats.painting_animations || 0, icon: '🎨', color: '#eb2f96' },
          { label: 'AI动画', value: stats.ai_animations || 0, icon: '🤖', color: '#52c41a' },
          { label: '活动照片', value: stats.photos || 0, icon: '📷', color: '#faad14' },
        ].map((s, i) => (
          <div key={i} style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>{s.icon}</div>
            <div style={{ fontSize: 28, fontWeight: 600, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 13, color: '#666' }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* 筛选器 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <select
          value={selectedChild}
          onChange={e => setSelectedChild(e.target.value)}
          style={{ padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, minWidth: 200 }}
        >
          <option value="">全部孩子</option>
          {children.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>

        {['all', 'growth_video', 'painting_animation', 'ai_animation', 'photo'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              background: filter === f ? '#1890ff' : '#f5f5f5',
              color: filter === f ? '#fff' : '#666',
              fontSize: 13
            }}
          >
            {f === 'all' ? '全部' : getTypeName(f)}
          </button>
        ))}
      </div>

      {/* 资产列表 */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>加载中...</div>
        ) : assets.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>
            暂无资产{selectedChild ? '，请先选择孩子' : ''}
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16, padding: 20 }}>
            {assets.map(a => (
              <div key={a.id} style={{ border: '1px solid #f0f0f0', borderRadius: 8, overflow: 'hidden' }}>
                {(a.url || a.thumbnail) ? (
                  (a.asset_type === 'photo' || a.url?.match(/\.(jpg|jpeg|png|gif|webp)/i) || (!a.asset_type)) ? (
                    <img
                      src={a.thumbnail || a.url}
                      alt={a.title || ''}
                      style={{ width: '100%', height: 120, objectFit: 'cover', background: '#f5f5f5' }}
                      onError={e => {
                        try {
                          const src = e.target.src
                          if (src.startsWith('http://tmp/') || src.includes('wxfile://tmp')) {
                            // 脏数据路径,跳过
                            e.target.style.display = 'none'
                            const fb = e.target.parentNode?.querySelector?.('.fallback-icon')
                            if (fb) fb.style.display = 'flex'
                          } else if (!src.startsWith('https://') && !src.startsWith('http://')) {
                            e.target.src = 'https://api.boxiaotu.cn' + (src.startsWith('/') ? '' : '/storage/') + src
                          } else {
                            e.target.style.display = 'none'
                            const fb = e.target.parentNode?.querySelector?.('.fallback-icon')
                            if (fb) fb.style.display = 'flex'
                          }
                        } catch (_) { console.error(_) }
                      }}
                    />
                  ) : (
                    <div style={{ width: '100%', height: 120, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ fontSize: 40 }}>🎬</span>
                    </div>
                  )
                ) : (
                  <div className="fallback-icon" style={{ height: 120, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 40 }}>
                    {getTypeIcon(a.asset_type)}
                  </div>
                )}
                <div style={{ padding: 12 }}>
                  <div style={{ fontWeight: 500, marginBottom: 4 }}>{a.title || getTypeName(a.asset_type)}</div>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>
                    {a.child_name && <span>👶 {a.child_name}</span>}
                    {a.parentPhone && <span style={{ marginLeft: 8, color: '#999' }}>📱 {a.parentPhone}</span>}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 11, color: '#999' }}>{a.created_at?.slice(0, 10) || a.date?.slice(0, 10)}</span>
                    <button
                      onClick={() => handleDelete(a.id)}
                      style={{ padding: '4px 8px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11 }}
                    >
                      删除
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 说明 */}
      <div style={{ marginTop: 20, background: '#fff', borderRadius: 8, padding: 16 }}>
        <h4 style={{ marginBottom: 8 }}>📋 资产来源</h4>
        <ul style={{ color: '#666', fontSize: 13, lineHeight: 2, paddingLeft: 20 }}>
          <li>🎬 <strong>成长纪念视频</strong> - 活动照片制作的成长视频</li>
          <li>🎨 <strong>画作动画</strong> - 孩子的画作AI动画</li>
          <li>🤖 <strong>AI动画</strong> - AI创作营学员作业产出的动画</li>
          <li>📷 <strong>活动照片</strong> - 职业体验、生日派对等活动照片</li>
        </ul>
        <p style={{ color: '#999', fontSize: 12, marginTop: 8 }}>
          资产会在家长使用领取码兑换后自动归入孩子账户
        </p>
      </div>
    </div>
  )
}
